import Response from "../../Data/Domain/Response";
import { uploadFile } from "./ImportFile.service";
import ScriptOffset from "../../ScriptOffsets/Domain/ScriptOffsets";

export async function importRepository(userId, file) {
  const data = await uploadFile(userId, file);
  return new Response(data, ScriptOffset).getMultiple().resources;
}
